import React from 'react';

type Variant = 'outline' | 'filled' | 'white';
type Size = 'sm' | 'md' | 'lg';

const VARIANT_CLASSES: Record<Variant, string> = {
  outline:
    'border-2 border-primary text-primary hover:bg-primary hover:text-white',
  filled:
    'bg-primary text-white hover:text-primary hover:bg-white hover:border-2 border-primary',
  white: 'border-2 border-white text-white hover:bg-white hover:text-primary',
};

const SIZE_CLASSES: Record<Size, string> = {
  lg: 'inline-flex h-16 w-80 items-center justify-center rounded-full px-8 py-3 text-lg font-semibold',
  md: 'inline-flex h-14 items-center justify-center rounded-full px-12 text-lg font-semibold',
  sm: 'inline-flex items-center justify-center rounded-full px-4 py-1.5 text-sm font-semibold',
};

type Props = {
  href: string;
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  className?: string;
  target?: string;
  rel?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

export const OutlinePrimaryLink: React.FC<Props> = ({
  href,
  children,
  variant = 'outline',
  size = 'lg',
  className,
  target,
  rel,
  onClick,
}) => (
  <a
    href={href}
    target={target}
    rel={rel}
    onClick={onClick}
    className={`${SIZE_CLASSES[size]} ${VARIANT_CLASSES[variant]}${
      className ? ` ${className}` : ''
    }`}>
    {children}
  </a>
);
